/* eslint-disable max-len */
import React from 'react';

export const SsoSVG = ({
  brandSecondary,
  brandPrimary,
  brandSecondaryBackground,
  brandTint,
  brandShade1,
  brandShade2,
  brandPrimaryBackground,
}: SVGThemeProps) => (
  <svg
    width={280}
    height={216}
    viewBox="0 0 280 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Single Sign-On illustration"
  >
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.295 147.339C84.8673 147.339 54.2438 108.36 54.2438 74.9712C54.2438 41.5822 84.8673 20.4717 115.295 20.4717C145.723 20.4717 188.259 47.5382 188.259 80.9272C188.259 114.316 145.723 147.339 115.295 147.339Z"
        fill={brandTint}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.25}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.3875 16.4054C146.62 12.1614 172.858 21.4894 207.566 48.9269C237.938 72.9354 246.643 109.76 241.703 132.46C236.89 154.579 222.383 173.597 201.936 178.88C181.769 184.09 162.31 177.725 132.179 151.206C102.047 124.687 77.617 122.358 59.6555 118.191C41.694 114.025 17.0445 100.527 20.2135 72.8374C23.383 45.1474 70.0935 19.0379 99.3875 16.4054Z"
        fill={brandSecondary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.25}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.3327 192.722C62.7982 178.634 48.4057 157.643 54.3587 120.823C59.7862 87.2496 91.0622 58.7521 138.903 57.6856C186.885 56.6156 214.529 101.978 209.39 120.802C204.251 139.627 168.32 122.956 161.685 151.716C155.05 180.477 153.272 196.447 128.407 201.237C108.102 205.149 90.9367 198.927 82.3327 192.722Z"
        fill={brandPrimary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.502404}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M235.051 58.4366C208.267 31.6526 147 39.0081 117.61 68.3981C88.22 97.7881 96.5935 143.326 123.377 170.11C150.161 196.894 211.428 210.51 240.818 181.12C270.208 151.73 261.835 85.2201 235.051 58.4366Z"
        fill={brandSecondaryBackground}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.925 170.982H117.075C112.634 170.982 109 167.348 109 162.908V54.075C109 49.6335 112.634 46 117.075 46H165.925C170.367 46 174 49.6335 174 54.075V162.908C174 167.348 170.367 170.982 165.925 170.982Z"
      fill={brandShade2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.925 170.982H114.075C109.634 170.982 106 167.348 106 162.908V54.075C106 49.6335 109.634 46 114.075 46H162.925C167.367 46 171 49.6335 171 54.075V162.908C171 167.348 167.367 170.982 162.925 170.982Z"
      fill={brandPrimary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.892 158.919C111.279 158.919 110.78 158.421 110.78 157.808V61.8244C110.78 61.2114 111.279 60.7129 111.892 60.7129H165.109C165.721 60.7129 166.22 61.2114 166.22 61.8244V157.808C166.22 158.421 165.721 158.919 165.109 158.919H111.892Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.247 55.6816H146.754C147.164 55.6816 147.5 55.3461 147.5 54.9356V54.4281C147.5 54.0176 147.164 53.6816 146.754 53.6816H133.247C132.836 53.6816 132.5 54.0176 132.5 54.4281V54.9356C132.5 55.3461 132.836 55.6816 133.247 55.6816Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M130.247 55.6816H130.754C131.164 55.6816 131.5 55.3461 131.5 54.9356V54.4281C131.5 54.0176 131.164 53.6816 130.754 53.6816H130.247C129.836 53.6816 129.5 54.0176 129.5 54.4281V54.9356C129.5 55.3461 129.836 55.6816 130.247 55.6816Z"
      fill={brandTint}
    />
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190 108.111C190 109.216 189.105 110.111 188 110.111C186.895 110.111 186 109.216 186 108.111C186 107.007 186.895 106.111 188 106.111C189.105 106.111 190 107.007 190 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208 108.111C208 109.768 206.656 111.111 205 111.111C203.344 111.111 202 109.768 202 108.111C202 106.455 203.344 105.111 205 105.111C206.656 105.111 208 106.455 208 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228 108.111C228 110.32 226.209 112.111 224 112.111C221.791 112.111 220 110.32 220 108.111C220 105.902 221.791 104.111 224 104.111C226.209 104.111 228 105.902 228 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M252 108.111C252 111.425 249.313 114.111 246 114.111C242.687 114.111 240 111.425 240 108.111C240 104.797 242.687 102.111 246 102.111C249.313 102.111 252 104.797 252 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M280 108.111C280 112.529 276.418 116.111 272 116.111C267.582 116.111 264 112.529 264 108.111C264 103.693 267.582 100.111 272 100.111C276.418 100.111 280 103.693 280 108.111Z"
        fill={brandSecondary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90 108.111C90 107.007 90.8955 106.111 92 106.111C93.1045 106.111 94 107.007 94 108.111C94 109.216 93.1045 110.111 92 110.111C90.8955 110.111 90 109.216 90 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72 108.111C72 106.455 73.3435 105.111 75 105.111C76.6565 105.111 78 106.455 78 108.111C78 109.768 76.6565 111.111 75 111.111C73.3435 111.111 72 109.768 72 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52 108.111C52 105.902 53.791 104.111 56 104.111C58.209 104.111 60 105.902 60 108.111C60 110.32 58.209 112.111 56 112.111C53.791 112.111 52 110.32 52 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 108.111C28 104.797 30.6865 102.111 34 102.111C37.3135 102.111 40 104.797 40 108.111C40 111.425 37.3135 114.111 34 114.111C30.6865 114.111 28 111.425 28 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 108.111C0 103.693 3.5815 100.111 8 100.111C12.4185 100.111 16 103.693 16 108.111C16 112.529 12.4185 116.111 8 116.111C3.5815 116.111 0 112.529 0 108.111Z"
        fill={brandSecondary}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M139.5 126.491C129.559 126.491 121.5 118.432 121.5 108.491C121.5 98.5497 129.559 90.4912 139.5 90.4912C149.442 90.4912 157.5 98.5497 157.5 108.491C157.5 118.432 149.442 126.491 139.5 126.491Z"
      fill={brandSecondary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M147.089 120V102.5H144.857V100.312C144.857 99.5879 144.257 99 143.518 99H135.482C134.743 99 134.143 99.5879 134.143 100.312V102.5H131.911V120H147.089ZM143.071 102.5H135.929V100.75H143.071V102.5ZM130.571 102.5V120H130.125C128.409 120 127 118.619 127 116.938V105.562C127 103.881 128.409 102.5 130.125 102.5H130.571ZM148.875 120C150.591 120 152 118.619 152 116.938V105.562C152 103.881 150.591 102.5 148.875 102.5H148.429V120H148.875ZM138.161 116.5H140.839C141.09 116.5 141.286 116.309 141.286 116.062V113H144.411C144.662 113 144.857 112.809 144.857 112.562V109.938C144.857 109.691 144.662 109.5 144.411 109.5H141.286V106.438C141.286 106.191 141.09 106 140.839 106H138.161C137.91 106 137.714 106.191 137.714 106.438V109.5H134.589C134.338 109.5 134.143 109.691 134.143 109.938V112.562C134.143 112.809 134.338 113 134.589 113H137.714V116.062C137.714 116.309 137.91 116.5 138.161 116.5Z"
      fill={brandShade1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M147.089 119V101.5H144.857V99.3125C144.857 98.5879 144.257 98 143.518 98H135.482C134.743 98 134.143 98.5879 134.143 99.3125V101.5H131.911V119H147.089ZM143.071 101.5H135.929V99.75H143.071V101.5ZM130.571 101.5V119H130.125C128.409 119 127 117.619 127 115.938V104.562C127 102.881 128.409 101.5 130.125 101.5H130.571ZM148.875 119C150.591 119 152 117.619 152 115.938V104.562C152 102.881 150.591 101.5 148.875 101.5H148.429V119H148.875ZM138.161 115.5H140.839C141.09 115.5 141.286 115.309 141.286 115.062V112H144.411C144.662 112 144.857 111.809 144.857 111.562V108.938C144.857 108.691 144.662 108.5 144.411 108.5H141.286V105.438C141.286 105.191 141.09 105 140.839 105H138.161C137.91 105 137.714 105.191 137.714 105.438V108.5H134.589C134.338 108.5 134.143 108.691 134.143 108.938V111.562C134.143 111.809 134.338 112 134.589 112H137.714V115.062C137.714 115.309 137.91 115.5 138.161 115.5Z"
      fill="white"
    />
    <rect x={133} y={103} width={13} height={14} fill="white" />
    <path
      d="M145.786 110.304C145.786 109.86 145.426 109.5 144.982 109.5H141.5V106.018C141.5 105.574 141.14 105.214 140.696 105.214H139.089C138.646 105.214 138.286 105.574 138.286 106.018V109.5H134.804C134.36 109.5 134 109.86 134 110.304V111.911C134 112.354 134.36 112.714 134.804 112.714H138.286V116.196C138.286 116.64 138.646 117 139.089 117H140.696C141.14 117 141.5 116.64 141.5 116.196V112.714H144.982C145.426 112.714 145.786 112.354 145.786 111.911V110.304Z"
      fill="#DC200C"
    />
  </svg>
);
